export default class MembershipCtrl {
  constructor(userModel, cancelMembershipService) {
    'ngInject';

    this.userModel = userModel;
    this.expires = this.userModel.item.membership.expires;

    this.cancelSubscription = function () {
      this.loading = true;
      cancelMembershipService.open().then(() => {
        this.userModel.item.membership.recurring = false;
      }).finally(() => {
        this.loading = false;
      });
    };
  }
}



// WEBPACK FOOTER //
// ./app/src/modules/membership/membership.controller.js